import { createApiClient } from '../../api/client';
import { useLocalData } from '../../hooks/useLocalData';

export function useApiClient() {
  const { getLocalData, APP_AUTH_STORAGE_KEY, APP_AUTH_TOKEN_KEY } = useLocalData();
  const token = getLocalData(APP_AUTH_STORAGE_KEY)?.[APP_AUTH_TOKEN_KEY] ?? '';
  return createApiClient(token);
}
